import React from 'react';
import { jc } from 'utils';
import { Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import {
  firstRow,
  likeDislikeGroupWrapper,
  prosConsContent,
  prosConsLabel,
  ratingWrapper,
  reviewAdditionalWrapper,
  textRow,
  textRowProsCons,
} from './review.styles';
import { ReviewAuthorContentProps } from './review-author-content';
import { ReviewRatingScoreProps } from './review-rating-score';

type ReviewProps = {
  author: React.ReactElement<ReviewAuthorContentProps>;

  ratingScore: React.ReactElement<ReviewRatingScoreProps>;

  additionalInfo: React.ReactNode;
  variantString: React.ReactNode;

  text: React.ReactNode;
  pros?: React.ReactNode;
  cons?: React.ReactNode;
  likeDislikeGroup?: React.ReactNode;

  photos?: React.ReactElement;
} & React.HTMLAttributes<HTMLElement>;

export const Review: React.FC<ReviewProps> = ({
  author,
  className,
  ratingScore,
  additionalInfo,
  variantString,
  text,
  pros,
  cons,
  likeDislikeGroup,
  photos,
  ...htmlProps
}) => {
  const { t } = useTranslation();
  return (
    <div className={className} {...htmlProps}>
      <div className={firstRow}>{author}</div>

      <div className={reviewAdditionalWrapper}>
        <div className={ratingWrapper}>
          {ratingScore}

          {additionalInfo}
        </div>

        {variantString}
      </div>

      {photos && <>{photos}</>}

      <div className={textRow}>{text}</div>

      {pros ? (
        <div className={jc(textRow, textRowProsCons)}>
          <Typography className={prosConsLabel} variant="s" size="body_accent">
            {t('reviews.review.pros')}
          </Typography>
          <div className={prosConsContent}>{pros}</div>
        </div>
      ) : null}
      {cons ? (
        <div className={jc(textRow, textRowProsCons)}>
          <Typography className={prosConsLabel} variant="s" size="body_accent">
            {t('reviews.review.cons')}
          </Typography>
          <div className={prosConsContent}>{cons}</div>
        </div>
      ) : null}

      {likeDislikeGroup ? (
        <div
          data-testid="like-dislike-group__wrapper"
          data-qa="like-dislike-group__wrapper"
          className={likeDislikeGroupWrapper}
        >
          {likeDislikeGroup}
        </div>
      ) : null}
    </div>
  );
};
